import { dataAPI } from "../api"
import { ItemResourceDTO } from "../models/resources"
import { IItem } from "../../components/resources"
import { ODataGetResourceResponse } from "../models/api/data"

export const getItem = (id: number): Promise<IItem> =>
    dataAPI
        .getJSON<ODataGetResourceResponse<ItemResourceDTO>>(
            `items(${id})?$expand=concept($expand=workspace)`,
        )
        .then((Item) => {
            const { Concept } = Item
            const { Workspace } = Concept
            const newItem: IItem = {
                id: Item.Id,
                title: Item.Label,
                doesExist: true,
                concept: {
                    id: Concept.Id,
                    title: Concept.Label,
                    doesExist: true,
                    workspace: {
                        id: Workspace.Id,
                        title: Workspace.Label,
                        doesExist: true,
                    },
                },
            }

            return newItem
        })
